import React, { memo } from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { useIntl } from 'react-intl';

const ProjectTabs = () => {
  const translate = useIntl();
  const { url } = useRouteMatch();

  return (
    <div className="project__navigation">
      <NavLink className="link" activeClassName="link_active" to={`${url}`} exact>
        {translate.formatMessage({ id: 'projectPage.projectInformation' })}
      </NavLink>
      <NavLink className="link" activeClassName="link_active" to={`${url}/field-agents`} exact>
        {translate.formatMessage({ id: 'projectPage.fieldAgents' })}
      </NavLink>
      <NavLink className="link" activeClassName="link_active" to={`${url}/monitoring`}>
        {translate.formatMessage({ id: 'projectPage.monitoringData' })}
      </NavLink>
      <NavLink className="link" activeClassName="link_active" to={`${url}/carbon`}>
        {translate.formatMessage({ id: 'projectPage.carbon' })}
      </NavLink>
    </div>
  );
};

export default memo(ProjectTabs);
